import { CurveRange, random } from 'cc';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    export interface CurveRange {
        /**
         * Evaluate the curve at a given time.
         * @param time time ratio
         * @param rndRatio random ratio, only used when mode is not Constant or Curve, default is random()
         */
        evaluate(time: number, rndRatio?: number): number;
    }
}

// curve range is only available when particle system is enabled in project settings
if (CurveRange) {
    const originEvaluate = CurveRange.prototype.evaluate;
    CurveRange.prototype.evaluate = function evaluate(this: CurveRange, time: number, rndRatio?: number): number {
        if (this.mode !== CurveRange.Mode.Constant && this.mode !== CurveRange.Mode.Curve && (rndRatio === undefined || rndRatio === null)) {
            rndRatio = random();
        }
        return originEvaluate.call(this, time, rndRatio);
    };
}
